/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ApiActionsModel {
        public currentApiAction: Wars.Domain.Model.ApiAction;
        public objectQueries: Wars.Domain.Model.ObjectQuery[];
        public apiActions: Wars.Domain.Model.ApiAction[];
        public autoCompleteConfigurations: Wars.Domain.Model.AutoCompleteConfiguration[];
        public allowMapping: boolean = true;
        public reload: boolean = false;

        constructor(private processConfigurationId: string, private apiActionService: services.ApiActionService,
            private objectQueryService: services.ObjectQueryService, private objectSchemaService: services.ObjectSchemaService,
            private apiSchemaMappingService: services.ApiSchemaMappingService) {

            apiActionService.getApiActions(processConfigurationId).then(result => {
                //console.log(result);
                this.apiActions = result;
            });

            objectQueryService.getAllObjectQueriesForProcessConfiguration(processConfigurationId).then(result => {
                this.objectQueries = result;
            });
        }

        public save(callback?: any) {
            this.apiActionService.saveAllChanges(callback);
        }

        public selectAction(apiAction: Wars.Domain.Model.ApiAction) {
            this.currentApiAction = apiAction;

            this.reload = true;
        }

        public addApiAction() {
            this.currentApiAction = this.apiActionService.createApiAction();
            this.currentApiAction.processConfiguration_id = this.processConfigurationId;
            this.currentApiAction.isActive = false;

            this.apiActions.push(this.currentApiAction);
            this.save();
        }

        public copySchema() {
            if (this.currentApiAction.objectQuery.myInputObjectSchema) {
                this.currentApiAction.inputObjectSchema = this.objectSchemaService.cloneObjectSchema(this.currentApiAction.objectQuery.myInputObjectSchema);
                this.addObjectSchemaMappingFromCopy(<warsApp.models.ObjectSchema>this.currentApiAction.inputObjectSchema, Wars.Domain.Model.Codes.Enums.SchemaMappingType.Input);
            }

            this.currentApiAction.outputObjectSchema = this.objectSchemaService.cloneObjectSchema(this.currentApiAction.objectQuery.myProjectionObjectSchema);
            this.addObjectSchemaMappingFromCopy(<warsApp.models.ObjectSchema>this.currentApiAction.outputObjectSchema, Wars.Domain.Model.Codes.Enums.SchemaMappingType.Output);


            this.save(() => {
                this.reload = true;
            });
        }

        public remapSchema() {
            this.currentApiAction.apiSchemaMappings.forEach(mapping => {
                if (mapping.type == Wars.Domain.Model.Codes.Enums.SchemaMappingType.Output) {
                    this.setMappedPropId(this.currentApiAction.objectQuery.myProjectionObjectSchema, mapping);
                }
                else {
                    this.setMappedPropId(this.currentApiAction.objectQuery.myInputObjectSchema, mapping)
                }
            });



            this.save(() => {
                this.reload = true;
            });
        }

        private setMappedPropId(objectSchema: Wars.Domain.Model.ObjectSchema, mapping: Wars.Domain.Model.SchemaMapping): boolean {
            var foundProp = Enumerable.from(objectSchema.properties).firstOrDefault(p => p.name == mapping.leftSchemaProperty.name);

            if (foundProp) {
                mapping.rightSchemaProperty_id = foundProp.id;
                //console.log('found ' + mapping.leftSchemaProperty.name);
                return;
            }
            //console.log('not found ' + mapping.leftSchemaProperty.name);
        }

        private addObjectSchemaMappingFromCopy(objectSchema: warsApp.models.ObjectSchema, type: Wars.Domain.Model.Codes.Enums.SchemaMappingType) {
            objectSchema.properties.forEach(prop => {
                let newMapping = this.apiSchemaMappingService.createApiSchemaMapping();

                newMapping.apiAction_id = this.currentApiAction.id;
                newMapping.leftSchemaProperty_id = prop.id;
                newMapping.rightSchemaProperty_id = prop.clonedFromId;
                newMapping.type = type;

                this.currentApiAction.apiSchemaMappings.push(newMapping);
            });
        }

        public deleteAction() {
            if(this.currentApiAction.isActive){
                return;
            }
            this.currentApiAction.apiSchemaMappings.forEach(a=>{
               a.entityAspect.setDeleted(); 
            });
            
            this.save(()=>{
                this.currentApiAction.entityAspect.setDeleted();
                this.save();
                this.apiActions.remove(this.currentApiAction);
                this.currentApiAction = null;
            })
        }
    }
}